import { get } from "lodash";
import { PROFILE_LIST } from "utils/constants";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const SubscriptionDone = ({ project, onBack, currentStatus }) => {
  const isRenaultEmployee =
    get(project, "contact.fields.profile") === PROFILE_LIST.RENAULT_EMPLOYEE;
  const title = isRenaultEmployee
    ? "Merci pour votre confiance"
    : "Bienvenu à Mobilité Mutuelle";

  return (
    <>
      <Navbar
        project={project}
        progress={currentStatus?.progress}
        showHelp={false}
        step={5}
        stepCount={5}
        title={title}
      />
      <View onBack={onBack} isRenaultEmployee={isRenaultEmployee} />
    </>
  );
};

export default SubscriptionDone;
